import gql from "graphql-tag";

const EDIT_PAGE_MUTATION = gql` 
mutation EditPage($pageData: PageEditInput!) {
    editPage(pageData:$pageData){
    id
    slug
    title
    body
    parent { 
        id
    }
    createdAt
    updatedAt
    }
  }
`;
export default EDIT_PAGE_MUTATION;